import React, { cloneElement, forwardRef, useEffect, useState } from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useListController,
  useStore,
} from 'react-admin'
import { Container, IconButton, Tooltip } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { clientServices } from 'src/services/auth/client/client.service'
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import FileCopyIcon from '@mui/icons-material/FileCopy'
import { SelectClientModal } from './logic/SelectClientModal'
import { HasPermission } from 'src/helper/HasPermission'
import { width } from '@mui/system'

export function RoleList(props) {
  const translate = useTranslate()
  const { setSort, isFetching, refetch } = useListController()
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()
  const [clientOptions, setClientOptions] = useState([])
  const [clientsLoading, setClientsLoading] = useState(false)
  const [clientModal, setClientModal] = useState(false)
  const [selectedId, setSelectedId] = useState(null)

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  useEffect(() => {
    if (isSorting && isFetching) {
      setIsLoading(true)
    } else if (isLoading && isSorting && !isFetching) {
      setIsLoading(false)
      setIsSorting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSorting, isFetching])

  const onClickSort = (sort) => {
    setSort(sort)
    setIsSorting(true)
  }

  const hasPermissions = () => {
    return permissions?.options?.revision ||
      permissions?.hasShow ||
      permissions?.hasEdit ||
      permissions?.options?.delete
  }

  let searchTimeoutBusinessUnit
  const onSearch = async (name) =>{
    if(name.length < 2){
      setClientOptions([])
      return
    }
    clearTimeout(searchTimeoutBusinessUnit)
    setClientsLoading(true)
    searchTimeoutBusinessUnit = setTimeout(async () => {
      await clientServices.getByAll(name).then(res=>{
        setClientOptions(res)
      }).finally(()=>{
        setClientsLoading(false)
      })
    }, 1000)
  }

  const rolesFilters = [
    <TextInput label={translate('ra.field.id')} source='id' defaultValue='' />,
    <TextInput label={translate('ra.field.short_name')} source='short_name' defaultValue='' />,
    <TextInput label={translate('ra.field.long_name')} source='long_name' defaultValue='' />,
    <TextInput label={translate('ra.field.application_id')} source='application_id' defaultValue='' />,
    <EditInputsWrap
            label={translate('ra.field.client')}
            md={12}
            source="client_id"
          >
    <MultiAutocompleteInput
        fields={['long_name']}
        onSearch={onSearch}
        useOptionValue
        useOptionValueByOptions
        loading={clientsLoading}
        positionOptionsText={0}
        source="client_id"
        options={clientOptions}
      />
    </EditInputsWrap>
      
  ]
  
  {/* <TextInput parse={} label={translate('ra.field.client_id')} source='client_id' defaultValue='' />, */}



  const CloneButton = ({id})=>{
    return(
      <HasPermission resource={'permissionByRole'} permission='create'>
      <Tooltip placement='top' title='Clonar' >
          <IconButton size='small' onClick={()=>{setSelectedId(id);setClientModal(true)}} aria-label='view reservation'>
            <FileCopyIcon fontSize='10px' color='info'/>
          </IconButton>

      </Tooltip>
      </HasPermission>
    )
  }
  
  {/* <TextInput parse={} label={translate('ra.field.client_id')} source='client_id' defaultValue='' />, */}

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.role')}>
        <List {...props} component='div' filters={rolesFilters} actions={<ListViewTopToolbar hasCreate={permissions?.hasCreate} />}>
          <Datagrid /* rowClick='show' */ setSort={onClickSort} isLoading={isLoading}>
            <TextField label={translate('ra.field.id')} source='id' />
            <TextField label={translate('ra.field.short_name')} source='short_name' />
            <TextField label={translate('ra.field.long_name')} source='long_name' />
            <TextField label={translate('ra.field.application')} source='application.long_name' />
            <TextField label={translate('ra.field.client')} source='client.long_name' />
            {hasPermissions() && (
              <ListViewActionsButtons label={translate('ra.field.action')} fieldsName={['short_name']} genderElement='masculine' CustomButton={CloneButton} />
            )}
          </Datagrid>
        </List>
      </CardCommon>
      <SelectClientModal refetch={refetch} open={clientModal} id={selectedId} onClose={()=>setClientModal(false)}/>
    </Container>
  )
}
